// False without the Clipboard API: execCommand('copy') copies the selection, not text.
export default async function copyToClipboard(text: string): Promise<boolean> {
    if (!('clipboard' in navigator)) {
        return false
    }

    await navigator.clipboard.writeText(text)

    return true
}
